import Vue from 'vue';
import Vuex from 'vuex';
import affiliates from "./affiliates";
import application from "./application";
import categories from "./categories";
import specials from "./specials";
import user from "./user";
Vue.use(Vuex);
export default function () {
  return new Vuex.Store({
    modules: {
      affiliates: affiliates,
      application: application,
      categories: categories,
      specials: specials,
      user: user
    },
    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  });
}